export default __webpack_public_path__ + "static/media/ic_ahu_scroll_next.c19d3867.svg";